import React, {useState} from 'react';

const FormLottery = () => {

    const [selectedOption, setSelectedOption] = useState("mt");

    const handleOptionChange = e => {
        setSelectedOption(e.target.value);
    };

    return (
        <div>
            <form action="/" method="post" name="mienuutien" id="mienuutien">
                <table style={{align: "center", cellSpacing: "0", cellPadding: "0"}}>
                    <tbody>
                    <tr>
                        <td>Chọn miền ưu tiên:</td>
                        <td>
                            <table style={{width: "100%", cellSpacing: "0", cellPadding: "0"}}>
                                <tbody>
                                <tr>
                                    <td><label>
                                        <input type="radio"
                                               className="lottery"
                                               name="mut"
                                               value="mn"
                                               checked={selectedOption === "mn"}
                                               onChange={e => handleOptionChange(e)}
                                               id="mut_0"/>
                                        Miền Nam,
                                    </label>
                                    </td>
                                    <td><label>
                                        <input type="radio"
                                               className="lottery"
                                               name="mut"
                                               value="mb"
                                               checked={selectedOption === "mb"}
                                               onChange={e => handleOptionChange(e)}
                                               id="mut_1"/>
                                        Miền Bắc,
                                    </label>
                                    </td>
                                    <td><label>
                                        <input type="radio"
                                               className="lottery"
                                               name="mut" value="mt"
                                               id="mut_2"
                                               checked={selectedOption === "mt"}
                                               onChange={e => handleOptionChange(e)}
                                        />
                                        Miền Trung
                                    </label>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </form>
        </div>
    );

};

export default FormLottery;
